import React, {useEffect, useState} from 'react';
import { Modal, Button } from 'react-bootstrap';
import { getLabel } from '../../language'
import "../Settings/Setting.css"
import {message} from "antd";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
message.config({top:50})

const mapStateToProps = state => ({
    currentUser: state.common.currentUser,
    anonymousMode: state.user.anonymousMode
});

const PrivacyModal = props => {
    const [isDisables,setDisabled]=useState(true)

    useEffect(()=>{
        const {currentUser} = props;
        setDisabled(currentUser?.user_privilege?.mayPostToPublic)
        },[])

    const showErrorLabel73 = () => {
        if (!isDisables) {
            message.error(getLabel(274))
        }
    }

    return (
        <Modal className={`privacy-header ${props.anonymousMode ? "dark" : ""}`} show={props.state.privacyModal} onHide={props.privacyModal}>
            <Modal.Header>
                <Modal.Title>
                    {getLabel(51)}
                </Modal.Title>
                <button type="button" className="close" data-dismiss="modal" onClick={props.privacyModal} aria-hidden={props.state.privacyModal}>×</button>
            </Modal.Header>
            <Modal.Body>
                {   props.viewMyPostsAndComments &&
                    <div>
                        <legend className={`${props.anonymousMode ? "cw" : ""}`}>{getLabel(325)}</legend>
                        <fieldset className={`form-group privacy-list${props.anonymousMode ? "-dark cw" : ""}`}>
                          {!props.selectedAudience && <div className="form-check">
                                <input type="radio"  className="form-check-input" id="viewMyPostsAndComments1" onChange={props.onChange} onClick={props.onChange} disabled={props.isAudiencesList || false} name="viewMyPostsAndComments" checked={props.state.viewMyPostsAndComments == 1} value="1"/>
                                <label className="form-check-label" for="viewMyPostsAndComments1">
                                    {getLabel(71)}
                                </label>
                            </div>}
                            <div className="form-check">

                                <input type="radio" className="form-check-input" id="viewMyPostsAndComments2" onChange={props.onChange} name="viewMyPostsAndComments" checked={props.state.viewMyPostsAndComments == 2} value="2"/>
                                <label className="form-check-label" for="viewMyPostsAndComments2">
                                    {getLabel(72)}
                                </label>
                            </div>
                            <div className="form-check" onClick={showErrorLabel73}>

                                <input type="radio" disabled={!isDisables} className="form-check-input" onChange={props.onChange} id="viewMyPostsAndComments3" name="viewMyPostsAndComments" checked={props.state.viewMyPostsAndComments == 3} value="3"/>
                                <label for="viewMyPostsAndComments3"  className={` ${!isDisables ? "optionGrey" : "form-check-label"} form-check-label`}>
                                    {getLabel(73)}
                                </label>
                            </div>
                        </fieldset>
                    </div>
                }
                {   props.replyMyPostsAndComments &&
                    <div>
                        {getLabel(326)}
                        <fieldset className={`form-group privacy-list${props.anonymousMode ? "-dark cw" : ""}`}>
                          {props.state.errorMessage && props.state.errorMessage.message1 && <div className="text-danger">{props.state.errorMessage.message1}</div>}
                            <div className="form-check">
                                <input type="radio" className="form-check-input" id="replyMyPostsAndComments0"
                                       onChange={props.onChange} name="replyMyPostsAndComments"
                                       checked={props.state.replyMyPostsAndComments == 0} value="0"/>
                                <label className="form-check-label" htmlFor="replyMyPostsAndComments0">
                                    {getLabel(322)}
                                </label>
                            </div>
                          {!props.selectedAudience && <div className="form-check">
                                <input type="radio" className="form-check-input" onChange={props.onChange} onClick={props.onChange} disabled={props.isAudiencesList || false} id="replyMyPostsAndComments1" name="replyMyPostsAndComments" checked={props.state.replyMyPostsAndComments == 1} value="1"/>
                                <label className="form-check-label" for="replyMyPostsAndComments1">
                                    {getLabel(71)}
                                </label>
                            </div>}
                            <div className="form-check">
                                <input type="radio" className="form-check-input" onChange={props.onChange} id="replyMyPostsAndComments2"  name="replyMyPostsAndComments" checked={props.state.replyMyPostsAndComments == 2} value="2"/>
                                <label className="form-check-label" for="replyMyPostsAndComments2">
                                    {getLabel(72)}
                                </label>
                            </div>
                            <div className="form-check">
                                <input type="radio" className="form-check-input" onChange={props.onChange} id="replyMyPostsAndComments3"  name="replyMyPostsAndComments" checked={props.state.replyMyPostsAndComments == 3} value="3"/>
                                <label className="form-check-label" for="replyMyPostsAndComments3">
                                    {getLabel(73)}
                                </label>
                            </div>
                        </fieldset>
                        {getLabel(323)}
                    </div>
             }
            {   props.viewMyVotes &&
                <div>
                    <legend className={`${props.anonymousMode ? "cw" : ""}`}>{getLabel(105)}</legend>
                    <fieldset className={`form-group privacy-list${props.anonymousMode ? "-dark cw" : ""}`}>
                      {!props.selectedAudience && <div className="form-check">
                            <input type="radio"
                                   className="form-check-input"
                                   onChange={props.onChange}
                                   onClick={props.onChange}
                                   name="viewMyVotes"
                                   id="viewMyVotes1"
                                   value="1"
                                   checked={props.state.viewMyVotes == 1}
                            />
                            <label className="form-check-label" for="viewMyVotes1">{getLabel(71)}</label>
                        </div> }
                        <div className="form-check">
                            <input type="radio"
                                   className="form-check-input"
                                   onChange={props.onChange}
                                   name="viewMyVotes"
                                   id="viewMyVotes2"
                                   value="2"
                                   checked={props.state.viewMyVotes == 2}
                            />
                            <label className="form-check-label" for="viewMyVotes2">{getLabel(72)}</label>
                        </div>
                        <div className="form-check">
                            <input type="radio"
                                   className="form-check-input"
                                   onChange={props.onChange}
                                   name="viewMyVotes"
                                   id="viewMyVotes3"
                                   value="3"
                                   checked={props.state.viewMyVotes == 3}
                            />
                            <label className="form-check-label" for="viewMyVotes3">{getLabel(73)}</label>
                        </div>
                        {!props.isPoliticianQuestion &&
                        <div className="form-check">
                            <input type="radio"
                                   className="form-check-input"
                                   onChange={props.onChange}
                                   name="viewMyVotes"
                                   id="viewMyVotes4"
                                   value="4"
                                   checked={props.state.viewMyVotes == 4}
                            />
                            <label className="form-check-label" for="viewMyVotes4">{getLabel(78)}</label>
                        </div>
                        }
                    </fieldset>
                </div>
            }
            {
                props.isAudiencesList && (props.state.viewMyPostsAndComments == 1 || props.state.replyMyPostsAndComments == 1 )  &&
                <fieldset className="form-group privacy-list text-danger">
                    {getLabel(79)}
                </fieldset>
            }
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.privacyModal} className={`m-t-30 btn-primary${props.anonymousMode ? "-dark" : " custom-dp"}`}>{getLabel(80)}</Button>
            </Modal.Footer>
        </Modal>
    )

};
export default withRouter(connect(mapStateToProps)(PrivacyModal));

